(function () {
  // U.S. carrier holidays (USPS/UPS closed), with weekend-observed rule
  function nthDow(y, m, dow, n) { var d = new Date(y, m, 1); var off = (dow - d.getDay() + 7) % 7; return new Date(y, m, 1 + off + (n - 1) * 7); }
  function lastDow(y, m, dow) { var d = new Date(y, m + 1, 0); return new Date(y, m, d.getDate() - ((d.getDay() - dow + 7) % 7)); }
  function observed(d) { var w = d.getDay(); if (w === 6) return new Date(d.getFullYear(), d.getMonth(), d.getDate() - 1); if (w === 0) return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1); return d; }
  var hcache = {};
  function holidays(y) {
    if (hcache[y]) return hcache[y];
    var list = [observed(new Date(y, 0, 1)), nthDow(y, 0, 1, 3), nthDow(y, 1, 1, 3), lastDow(y, 4, 1), observed(new Date(y, 5, 19)), observed(new Date(y, 6, 4)), nthDow(y, 8, 1, 1), nthDow(y, 9, 1, 2), observed(new Date(y, 10, 11)), nthDow(y, 10, 4, 4), observed(new Date(y, 11, 25))];
    return (hcache[y] = list.map(function (d) { return d.toDateString(); }));
  }
  function isBizDay(d) { var w = d.getDay(); return w !== 0 && w !== 6 && holidays(d.getFullYear()).indexOf(d.toDateString()) === -1; }
  function addBizDays(d, n) {
    var x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    while (n > 0) { x.setDate(x.getDate() + 1); if (isBizDay(x)) n--; }
    return x;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  function fmtShort(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function fillDates(root) {
    (root || document).querySelectorAll('[data-rr-eta]').forEach(function (el) {
      var pMin = +el.dataset.pmin || 1, pMax = +el.dataset.pmax || 2, tMin = +el.dataset.tmin || 5, tMax = +el.dataset.tmax || 7;
      var now = new Date();
      var shipBy = addBizDays(now, pMax);
      var a = addBizDays(now, pMin + tMin), b = addBizDays(now, pMax + tMax);
      el.querySelectorAll('[data-rr-today]').forEach(function (n) { n.textContent = fmt(now); });
      el.querySelectorAll('[data-rr-shipby]').forEach(function (n) { n.textContent = fmt(shipBy); });
      el.querySelectorAll('[data-rr-arrive]').forEach(function (n) { n.textContent = fmtShort(a) + ' – ' + fmtShort(b); });
    });
  }

  function initHero(root) {
    root.querySelectorAll('[data-rr-hero]').forEach(function (hero) {
      if (hero.dataset.ready) return; hero.dataset.ready = '1';
      var dataEl = hero.querySelector('[data-rr-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = hero.querySelector('input[name="id"]');
      var btns = hero.querySelectorAll('button[data-rr-add]');
      var nowEl = hero.querySelector('[data-rr-now]'), wasEl = hero.querySelector('[data-rr-was]'), saveEl = hero.querySelector('[data-rr-save]');
      var groups = hero.querySelectorAll('[data-rr-opt]');
      var stickyPrice = document.querySelector('[data-rr-sticky-price="' + hero.dataset.rrHero + '"]');

      function selected() { return Array.prototype.map.call(groups, function (g) { var on = g.querySelector('[aria-pressed="true"]'); return on ? on.dataset.value : null; }); }
      function update() {
        var sel = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        groups.forEach(function (g, i) { var l = g.querySelector('[data-rr-opt-val]'); if (l) l.textContent = (sel[i] || '').split(' (')[0]; });
        if (!v) { btns.forEach(function (b) { b.setAttribute('disabled', 'disabled'); b.querySelector('span').textContent = 'Unavailable'; }); return; }
        idInput.value = v.id;
        if (nowEl) nowEl.textContent = v.price;
        if (stickyPrice) stickyPrice.textContent = v.price;
        if (wasEl) { wasEl.textContent = v.compare || ''; wasEl.hidden = !v.compare; }
        if (saveEl) { saveEl.textContent = v.save ? 'Save ' + v.save : ''; saveEl.hidden = !v.save; }
        btns.forEach(function (b) {
          var s = b.querySelector('span');
          if (v.available) { b.removeAttribute('disabled'); s.textContent = b.dataset.label; }
          else { b.setAttribute('disabled', 'disabled'); s.textContent = 'Sold out'; }
        });
        if (v.image) { var main = hero.querySelector('[data-rr-main]'); if (main) { main.src = v.image; main.removeAttribute('srcset'); } }
      }
      groups.forEach(function (g) {
        g.addEventListener('click', function (e) {
          var b = e.target.closest('[data-value]'); if (!b) return;
          g.querySelectorAll('[data-value]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          update();
        });
      });
      hero.querySelectorAll('[data-rr-thumb]').forEach(function (t) {
        t.addEventListener('click', function () {
          var main = hero.querySelector('[data-rr-main]');
          main.src = t.dataset.src; main.removeAttribute('srcset');
          hero.querySelectorAll('[data-rr-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        });
      });
      var sticky = document.querySelector('[data-rr-sticky="' + hero.dataset.rrHero + '"]');
      var anchor = hero.querySelector('[data-rr-add]');
      if (sticky && anchor && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { var past = !e.isIntersecting && e.boundingClientRect.top < 0; sticky.classList.toggle('is-on', past); });
        }).observe(anchor);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { var f = hero.querySelector('form'); if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type=submit]').click(); });
      }
      if (variants.length) update();
    });
  }

  function initTT(root) {
    root.querySelectorAll('[data-rr-tt]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var vids = sec.querySelectorAll('video');
      vids.forEach(function (v) { v.muted = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.loop = true; v.removeAttribute('controls'); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause(); });
        }, { threshold: 0.55 });
        vids.forEach(function (v) { io.observe(v); });
      }
      sec.querySelectorAll('[data-rr-sound]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.closest('.rr-tt__frame').querySelector('video'); if (!v) return;
          var turnOn = v.muted;
          vids.forEach(function (o) { o.muted = true; });
          sec.querySelectorAll('[data-rr-sound]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          v.muted = !turnOn; b.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
          if (turnOn) v.play();
        });
      });
      sec.querySelectorAll('[data-rr-embed]').forEach(function (b) {
        b.addEventListener('click', function () {
          var f = document.createElement('iframe');
          f.src = b.dataset.rrEmbed; f.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture'; f.allowFullscreen = true; f.title = 'TikTok video';
          b.parentNode.appendChild(f); b.remove();
        });
      });
    });
  }

  function init(root) { root = root || document; fillDates(root); initHero(root); initTT(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
